export default __webpack_public_path__ + "static/media/package-img2.e07ef152.jpg";